import React from 'react';
import { Table, Typography } from '../../components';

const { Title } = Typography;

export const ServicesTable = ({ services = [], osType, serviceManager }) => {
    if (!services || services.length === 0) return null;

    const columns = [
        { title: 'Service', dataIndex: 'caption', key: 'caption' },
        {
            title: 'Status',
            key: 'status',
            render: (_, service) => {
                if (!service.source.available) return 'n/a';

                if (osType === 'windows') {
                    return `${service.source.started ? 'Started' : 'Not Started'} (${service.source.start_mode})`;
                } else {
                    let status = service.source.active_status;
                    if (serviceManager === 'systemd') {
                        status += ` (${service.source.load_status})`;
                    } else if (serviceManager === 'upstart') {
                        status += ` (${service.source.goal_status})`;
                    }
                    return status;
                }
            },
        },
    ];

    return (
        <div className="inventory-section">
            <Title level={5}>Services</Title>
            <Table
                size="small"
                pagination={false}
                dataSource={services}
                columns={columns}
                rowKey={(item) => `service-${item.name || ''}-${item.caption || ''}`}
            />
        </div>
    );
};

export default ServicesTable;
